import { render } from "./OurThemes.vue?vue&type=template&id=79e61f91"
import script from "./OurThemes.vue?vue&type=script&lang=js"
export * from "./OurThemes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__